import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import GoablTempalate from '../../components/GoablTempalate';

const { Cell } = ResponsiveGrid;

function getObj() {
  return {
    service: 'communityFiles',
    name: '文件',
    display: false,
  };
}
const CommunityFiles = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="社區檔案列表"
        breadcrumbs={[
          {
            name: '社區檔案',
          },
          {
            name: '社區檔案列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <GoablTempalate data={getObj()} />
    </Cell>
  </ResponsiveGrid>
);

export default CommunityFiles;
